// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui.card [class*=\"center aligned\"],\n.ui.cards > .card [class*=\"center aligned\"] {\n  text-align: center;\n}\nspan.ui.large.text {\n  font-size: 1.5em;\n}\n", ""]);
// Exports
module.exports = exports;
